module.exports = __webpack_public_path__ + "img/appdownload-adr.43145cb7.png";